import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const LINKS = [{
  label: 'Work',
  hash: '#work'
}, {
  label: 'Services',
  hash: '#services'
}, {
  label: 'Process',
  hash: '#process'
}, {
  label: 'Pricing',
  hash: '#pricing'
}, {
  label: 'FAQ',
  hash: '#faq'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  // Lock body scroll while the mobile menu is open.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className="fixed inset-x-0 top-0 z-50 border-b" style={{
    borderColor: 'var(--line)',
    background: 'rgba(17, 16, 19, 0.72)',
    backdropFilter: 'blur(12px)'
  }} data-id="element-102">
      <div className="mx-auto flex h-16 md:h-20 max-w-[1400px] items-center justify-between px-5 md:px-10" data-id="element-103">
        <Link to="/" onClick={() => setOpen(false)} className="font-display text-xl md:text-2xl tracking-tight" data-id="element-104">
          NKALI
          <span style={{
          color: 'var(--danfo)'
        }} data-id="element-105">
            ®
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-106">
          {LINKS.map(l => <Link key={l.hash} to={{
          pathname: '/',
          hash: l.hash
        }} className="font-monoui text-xs uppercase tracking-[0.18em] opacity-60 transition-opacity hover:opacity-100" data-id="element-107">
              {l.label}
            </Link>)}
          <Link to="/about" className="font-monoui text-xs uppercase tracking-[0.18em] opacity-60 transition-opacity hover:opacity-100" data-id="element-108">
            About
          </Link>
        </nav>

        {/* Desktop CTA */}
        <Link to={{
        pathname: '/',
        hash: '#contact'
      }} className="hidden md:inline-block font-monoui text-xs uppercase tracking-[0.18em] px-6 py-3 transition-transform hover:-translate-y-0.5" style={{
        background: 'var(--danfo)',
        color: 'var(--ink)'
      }} data-id="element-109">
          Start a project
        </Link>

        {/* Mobile toggle */}
        <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="mobile-menu" className="md:hidden flex h-11 w-11 -mr-2 items-center justify-center" data-id="element-110">
          {open ? <XIcon size={26} aria-hidden="true" data-id="element-111" /> : <MenuIcon size={26} aria-hidden="true" data-id="element-112" />}
        </button>
      </div>

      {/* Mobile menu panel */}
      <div id="mobile-menu" className="md:hidden overflow-hidden border-t transition-[max-height] duration-500 ease-in-out" style={{
      maxHeight: open ? '80vh' : '0px',
      borderColor: open ? 'var(--line)' : 'transparent',
      background: 'var(--ink)'
    }} data-id="element-113">
        <nav className="flex flex-col px-5 py-4" data-id="element-114">
          {LINKS.map(l => <Link key={l.hash} to={{
          pathname: '/',
          hash: l.hash
        }} onClick={() => setOpen(false)} className="font-display uppercase text-2xl tracking-tight py-3 border-b transition-colors hover:text-[var(--danfo)]" style={{
          borderColor: 'var(--line)'
        }} data-id="element-115">
              {l.label}
            </Link>)}
          <Link to="/about" onClick={() => setOpen(false)} className="font-display uppercase text-2xl tracking-tight py-3 border-b transition-colors hover:text-[var(--danfo)]" style={{
          borderColor: 'var(--line)'
        }} data-id="element-116">
            About
          </Link>
          <Link to={{
          pathname: '/',
          hash: '#contact'
        }} onClick={() => setOpen(false)} className="font-monoui text-xs uppercase tracking-[0.18em] mt-5 mb-2 py-4 text-center transition-transform hover:-translate-y-0.5" style={{
          background: 'var(--danfo)',
          color: 'var(--ink)'
        }} data-id="element-117">
            Start a project
          </Link>
        </nav>
      </div>
    </header>;
}